module.exports = __webpack_public_path__ + "static/media/blog-category5.37904b07.png";